<template>
  <div class="video-box m-video-box">
    <video
      class="m-video"
      controls
      preload="auto"
      webkit-playsinline
      playsinline
      x-webkit-airplay="allow"
      muted="true"
      x5-video-player-type="h5"
      x5-video-player-fullscreen="true"
      x5-video-player-orientation="portrait"
    >
      <source :src="lessonUrl" type="video/mp4">
    </video>
  </div>
</template>

<script>
import { mixins } from '@/utils/mixins'
export default {
  name: 'Lesson',
  mixins: [mixins],
  data() {
    return {
      lessonUrl: null
    }
  },
  mounted() {
    // 设置页面标题
    document.title = '课程详情'

    this.lessonUrl = this.$route.query.lessonUrl
    const videoBox = document.querySelector('.m-video-box')
    const mVideo = videoBox.querySelector('.m-video')
    mVideo.width = videoBox.clientWidth
  }
}
</script>
